var render = function render(){var _vm=this,_c=_vm._self._c;return _c('check-form',{attrs:{"formId":_vm.formId}})
}
var staticRenderFns = []

export { render, staticRenderFns }